import { Expose, Type } from 'class-transformer';

export class UploadFilesServiceCallResponseDto {
  @Expose({ name: 'files' })
  @Type(() => FileServiceCallResponseDto)
  files: FileServiceCallResponseDto[];
}

export class FileServiceCallResponseDto {
  @Expose({ name: 'fileId' })
  fileId: string;
  @Expose({ name: 'format' })
  format: string;
  @Expose({ name: 'url' })
  url: string;
  @Expose({ name: 'filename' })
  filename: string;
  @Expose({ name: 'bytes' })
  bytes: string;
  @Expose({ name: 'resourceType' })
  resourceType: string;
}
